import { Sorting } from '@saucelabs/ds-filters';
import React from 'react';

import { SortAction, track } from '../../global/tracking';
import { DiffsOrderBy } from '../../graphql/__generated__/graphql';

export type DiffsOrderUI = Extract<
  DiffsOrderBy,
  DiffsOrderBy.CreatedAtAsc | DiffsOrderBy.StatusIsEqualAsc
>

export const orderDefault = DiffsOrderBy.StatusIsEqualAsc;

export const diffSortKey = 'DiffOrder';
export const diffSortValues: { [key in DiffsOrderUI]: DiffsOrderBy[] } = {
  CREATED_AT_ASC: [DiffsOrderBy.CreatedAtAsc],
  STATUS_IS_EQUAL_ASC: [DiffsOrderBy.StatusIsEqualAsc, DiffsOrderBy.CreatedAtAsc],
};

export function isOrderValid(value: string): value is DiffsOrderBy {
  return Object.values(DiffsOrderBy).includes(value as DiffsOrderBy);
}

type Props = {
  diffOrder: DiffsOrderBy
  setDiffsOrder: (order: DiffsOrderBy) => void
}

const diffSortOptions = [
  { value: DiffsOrderBy.CreatedAtAsc, label: 'Chronological order' },
  { value: DiffsOrderBy.StatusIsEqualAsc, label: 'Changed snapshots first' },
];

const DiffHeaderSort: React.FC<Props> = ({ diffOrder, setDiffsOrder }) => {
  const onSelect: (value: DiffsOrderBy) => void = (value) => {
    setDiffsOrder(value);

    track.resultsSorted(
      value === DiffsOrderBy.CreatedAtAsc ? SortAction.Chronological : SortAction.ChangedFirst,
    );
  };

  return (
    <Sorting
      data-qa="diff-sort-by"
      label="Sort by"
      onSelect={onSelect}
      options={diffSortOptions}
      selected={diffOrder}
    />
  );
};

export default DiffHeaderSort;
